import { Icon, useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Button } from '@/components_deprecated'
import React, { useRef } from 'react'
import styled from 'styled-components'
import { useMutation } from '@apollo/client'
import { CREATE_TACHO_DRIVER_FILE_MUTATION } from '../../mutations'

const Wrapper = styled.div`
  display: flex;

  div.buttons {
    display: flex;
    justify-content: flex-end;
  }
`

const ToolbarButton = styled(Button)`
  height: 38px;
  padding: 0 1.5rem;

  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;

  color: white;

  i {
    margin: 0 0.5rem 0 0;
  }
`

interface UploadTachoDriverFileProps {}

export const UploadTachoDriverFile: React.FC<
  UploadTachoDriverFileProps
> = () => {
  const translations = useTranslate({
    attachments: 'common.attachments',
    uploadFile: 'common.upload-file',
    fileAlreadyInSystem: 'activities.file-already-in-system',
    fileUploadedSuccessfully: 'activities.file-uploaded-successfully',
  })

  const fileInputRef = useRef<HTMLInputElement>(null)
  const addToast = useToast()

  const [addFile] = useMutation(CREATE_TACHO_DRIVER_FILE_MUTATION, {
    onCompleted: () => {
      addToast('success', translations.fileUploadedSuccessfully)
    },
    onError: () => {
      addToast('error', translations.fileAlreadyInSystem)
    },
  })

  function handleAddFile(file: File) {
    void addFile({
      variables: {
        input: {
          file: file,
          fileName: file.name,
          driverCardNumber: '',
          source: 'upload',
        },
      },
    })
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  return (
    <Wrapper className="mb-4">
      <input
        ref={fileInputRef}
        type="file"
        onChange={e => {
          if (e.target.files && e.target.files[0]) {
            handleAddFile(e.target.files[0])
          }
        }}
        hidden
      />
      <div className="buttons">
        <ToolbarButton
          className="attachment"
          onClick={() => fileInputRef.current?.click()}
        >
          {/* TODO not correct icon */}
          <Icon icon="add" type="regular" />
          {translations.uploadFile}
        </ToolbarButton>
      </div>
    </Wrapper>
  )
}
